// extracted by mini-css-extract-plugin
export default {"main":"Text_main__S9G39","firstTxt":"Text_firstTxt__WzCep","background":"Text_background__+1--N"};